import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
    return (
        <div className="min-h-screen bg-bone grid place-items-center px-4">
            <div className="card-soft p-10 max-w-md w-full text-center" data-testid="billing-cancel-page">
                <XCircle size={56} className="text-orange-400 mx-auto mb-4" />
                <h1 className="font-display text-2xl text-forest-dark mb-2">Pagamento annullato</h1>
                <p className="text-stone-600 mb-6">
                    Nessun problema! Puoi riprovare quando vuoi. La tua prova gratuita continua intanto.
                </p>
                <Link to="/billing" className="btn-primary">Torna al piano</Link>
            </div>
        </div>
    );
}
